module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "message-box__wrapper",
    staticStyle: {
      "z-index": "2002"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggeleClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "message-box"
  }, [_c('div', {
    staticClass: "message-box__header"
  }, [_c('button', {
    staticClass: "icon-close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggeleClick($event)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "message-box__content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.messageData)
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [_vm._v("\n''    "), _c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-7d2cb00a!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 301
// module chunks = 3